import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function WhatsAppFloat() {
  return <a href="https://wa.me/573160551859?text=Quiero%20construir%20mi%20imagen" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20bd5a] transition-colors hover:scale-110 duration-300 group" aria-label="Contactar por WhatsApp" data-id="element-310">
      <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" data-id="element-311"></div>
      <MessageCircleIcon className="h-7 w-7 relative z-10" data-id="element-312" />

      {/* Tooltip */}
      <span className="absolute right-full mr-4 bg-charcoal text-cream-50 text-xs py-2 px-3 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-313">
        ¿Te asesoramos?
      </span>
    </a>;
}